import React, { useEffect, useState } from 'react'

export type HookReturnValues = {
  code: string | null
  inputStates: InputState[]
  handleChange: (e: any, index: number) => void
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  handleSetCode: (values: number[]) => void
  handleClear: () => void
}

export type InputState = {
  digit: string
  setDigit: React.Dispatch<React.SetStateAction<string>>
}

const useVerificationCode = (inputClass: string): HookReturnValues => {
  let [code, setCode] = useState<string | null>(null)
  let inputStates: InputState[] = []

  const [digit1, setDigit1] = useState<string>('')
  const [digit2, setDigit2] = useState<string>('')
  const [digit3, setDigit3] = useState<string>('')
  const [digit4, setDigit4] = useState<string>('')
  const [digit5, setDigit5] = useState<string>('')
  const [digit6, setDigit6] = useState<string>('')

  inputStates.push({ digit: digit1, setDigit: setDigit1 })
  inputStates.push({ digit: digit2, setDigit: setDigit2 })
  inputStates.push({ digit: digit3, setDigit: setDigit3 })
  inputStates.push({ digit: digit4, setDigit: setDigit4 })
  inputStates.push({ digit: digit5, setDigit: setDigit5 })
  inputStates.push({ digit: digit6, setDigit: setDigit6 })

  const handleChange: HookReturnValues['handleChange'] = (e, index) => {
    let entry = e.target.value as string

    if (entry.length <= 1 && !Number.isNaN(entry)) {
      inputStates[index].setDigit(e.target.value)

      if (entry.length == 1) {
        if (index < 6 - 1) {
          let nextInput = document.querySelectorAll<HTMLInputElement>(`.${inputClass}`)[index + 1]

          if (nextInput.value == '') {
            nextInput.focus()
          }
        }
      } else if (entry.length == 0) {
        let prevInput = document.querySelectorAll<HTMLInputElement>(`.${inputClass}`)[index - 1]

        if (prevInput != undefined) {
          prevInput.focus()
        }
      }
    } else return
  }

  const handleSetCode = (values: number[]) => {
    inputStates.map((states, index) => {
      states.setDigit(String(values[index]))
    })
  }

  const handleClear = () => {
    inputStates.map((states) => {
      states.setDigit('')
    })
  }

  const handleKeyDown: HookReturnValues['handleKeyDown'] = (e) =>
    ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()

  useEffect(() => {
    let finalCode = inputStates.map((input) => input.digit).join('')

    if (finalCode.length == 6) {
      setCode(finalCode)
    } else {
      setCode(null)
    }
  }, [inputStates])

  return { code, inputStates, handleChange, handleKeyDown, handleSetCode, handleClear }
}

export default useVerificationCode
